import { Howl, Howler } from 'howler';
import noUiSlider from 'nouislider';

if (document.getElementById('audio-player')) {
    // Load Audio
    let sound = [];
    let currentTrack = 0;

    // Create the Audio Volume slider
    let volume_slider = document.getElementById('audio-volume');
    let slider = noUiSlider.create(volume_slider, { 
        start: 50,
        connect: [true, false],
        range: {
            'min': 0,
            'max': 100         
        },
        step: 1,
    });

    slider.on('update', (values) => {
        Howler.volume(values[0] / 100);
    });

    // Add Support for Keyboards
    let handle = volume_slider.querySelector('.noUi-handle');
    handle.setAttribute('aria-label', 'Volume slider handle');
    handle.addEventListener('keydown', (e) => {
        const value = Number(volume_slider.noUiSlider.get());
        if (e.which === 37) {
            slider.set(value - 5);
            var newVal = value - 0.05;
            Howler.volume(newVal / 100);
        }
        if (e.which === 39) {
            slider.set(value + 5);
            var newVal = value + 0.05;
            Howler.volume(newVal / 100);
        }
    });

    // Load the Theme Song with Vocals
    sound.push(new Howl({
        src: ['/wp-content/uploads/2018/10/07_-_-30_full_sing-00.mp3'],
        autoplay: false,
    }));

    // Load the Instrumental Version of the Song
    // sound.push(new Howl({
    //     src: ['/wp-content/uploads/2018/10/Touhou_Chireiden_Subterranean_Animism_Lullaby_of_Flame_OC_ReMix.mp3'],
    //     autoplay: false,
    // }));

    // Gather Buttons
    const button_mute = document.getElementById('audio-mute');
    const button_prev = document.getElementById('audio-prev');
    const button_next = document.getElementById('audio-next');
    const button_play = document.getElementById('audio-play');

    sound[0].on('end', () => {
        let icon = button_play.querySelector('i');
        icon.classList = 'fas fa-play';
    });

    // Handle Lyric display
    var loopID;
    function handleLyrics() {
        var pos = sound[currentTrack].seek();
        var lyrics = document.getElementById('currentLyrics');
        if ( pos >= 2 && pos <= 5.9 ) {
            lyrics.innerHTML = 'Choice, Change, Control';
        }
        else if ( pos >= 6 && pos <= 11.5 ) {
            lyrics.innerHTML = 'SEMO Alliance for Disability Independence';
        }
        else if ( pos >= 11.6 && pos <= 13 ) {
            lyrics.innerHTML = 'We provide you with a choice';
        }
        else if ( pos >= 13.1 && pos <= 15.4 ) {
            lyrics.innerHTML = 'A choice to help you make a change';
        }
        else if ( pos >= 15.5 && pos <= 17.3 ) {
            lyrics.innerHTML = 'A change to be independent';
        }
        else if ( pos >= 17.4 && pos <= 21 ) {
            lyrics.innerHTML = 'And have more control of your life';
        }
        else if ( pos >= 21.1 && pos <= 25 ) {
            lyrics.innerHTML = 'Choice, Change, Control';
        }
        else if ( pos >= 25.1 && pos <= 30 ) {
            lyrics.innerHTML = 'SEMO Alliance for Disability Independence';
        }
        else {
            lyrics.innerHTML = '';
        }
        loopID = requestAnimationFrame(handleLyrics);
    }

    // Handle Play Button
    button_play.addEventListener('click', (e) => {
        e.preventDefault();
        let icon = button_play.querySelector('i');

        if (!sound[currentTrack].playing()) {
            sound[currentTrack].play();
            icon.classList = 'fas fa-pause';
            loopID = requestAnimationFrame(handleLyrics);
        } else {
            sound[currentTrack].pause();
            icon.classList = 'fas fa-play';
            cancelAnimationFrame(loopID);
        }
        console.log(sound[currentTrack].seek());
    });

    // Handle Prev and Next
    button_prev.addEventListener('click', (e) => {
        e.preventDefault();
    });

    button_next.addEventListener('click', (e) => {
        e.preventDefault();
        let icon = button_play.querySelector('i');

        if (sound[currentTrack].playing()) {
            sound[currentTrack].stop();
            icon.classList = 'fas fa-play';
        }

        if (currentTrack < sound.length - 1) {
            currentTrack++;
        } else {
            currentTrack = 0;
        }

        e.preventDefault();
    });

    // Handle Mute Button
    button_mute.addEventListener('click', (e) => {
        e.preventDefault();

        let icon = button_mute.querySelector('i');

        Howler.mute(!Howler._muted);
        
        if (Howler._muted) {
            icon.classList = 'fas fa-volume-up';
        } else {
            icon.classList = 'fas fa-volume-slash';
        }
    });

}
